import React, { useContext, useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import ComposerContext from 'components/composer/contexts/composer_context';
import SearchableTaskAssignmentMenu from 'components/lib/assignment_menu/searchable_task_assignment_menu';
import UpdateTaskCompositionAssignee from 'actions/composition/update_task_composition_assignee';
import { useExecuteAction } from 'components/hooks/connect_hooks';

// A long assignee used to run past the composer edge: the header sets
// white-space: nowrap and nothing in the chain could shrink. Scoped here rather
// than in the shared CurrentAssignee, which other surfaces lay out differently.
const StyledSearchableTaskAssignmentMenu = styled(SearchableTaskAssignmentMenu)`
  margin-left: 4px;
  min-width: 0;

  .searchableTaskAssignment-assignee,
  .searchableTaskAssignment-assignee-text {
    min-width: 0;
  }

  .searchableTaskAssignment-assignee-text-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export default function AssigneeSelector() {
  const { t } = useTranslation();
  const { composition } = useContext(ComposerContext);
  const executeAction = useExecuteAction();
  const assignee = composition.content.assignee;
  const compositionId = composition.id;
  const onChangeAssignee = useCallback(
    attrs => {
      executeAction(UpdateTaskCompositionAssignee, {
        compositionId,
        customerId: composition.customerId,
        agentId: attrs.agentId,
        routingGroupId: attrs.routingGroupId,
      });
    },
    [compositionId, executeAction]
  );
  return (
    <StyledSearchableTaskAssignmentMenu
      agentId={assignee && assignee.agentId}
      label={t('Assign to')}
      onSelect={onChangeAssignee}
      routingGroupId={assignee && assignee.routingGroupId}
    />
  );
}
